export class ThemeConstants {
  public static readonly BASE_SPACING = 2
}
